import { combineReducers } from 'redux';
import analyticsReducer from './Analytics';
import configReducer from './Configuration';
import contextsReducer from './Contexts';
import flagsReducer from './Flags';
import hostPricingReducer from './HostPricing';
import installationReducer from './Installation';
import installedAppsReducer from './InstalledApps';
import scopesReducer from './Scopes';
import usersReducer from './Users';
export default combineReducers({
  analytics: analyticsReducer,
  configuration: configReducer,
  contexts: contextsReducer,
  flags: flagsReducer,
  hostPricing: hostPricingReducer,
  installation: installationReducer,
  installedApps: installedAppsReducer,
  scopes: scopesReducer,
  users: usersReducer
});